import React from 'react';

import { Tag as AntTag } from 'antd';
import { TagProps } from 'antd/lib/tag';
import { XmarkIcon } from '@revfluence/fresh-icons/solid';

import cn from 'classnames';
import { TagGroup } from './TagGroup';
import styles from './Tag.module.scss';

export interface ITagProps extends TagProps {
  size?: 'small' | 'default' | undefined;
  loading?: boolean;
}

type TTag = React.FC<ITagProps> & {
  Group: typeof TagGroup;
};

export const Tag: TTag = ({
  className,
  color = '',
  size = 'small',
  loading = false,
  closeIcon = <XmarkIcon />,
  ...props
}) => (
  <AntTag
    className={cn(
      styles.Tag,
      styles[color],
      { [styles.defaultSize]: size === 'default' },
      { [styles.loading]: loading },
      className
    )}
    color={color}
    closeIcon={closeIcon}
    {...props}
  />
);

Tag.Group = TagGroup;
